import React from 'react'
import { data } from '../../components/Index/tab/Data'
import { Link } from 'react-router-dom'
import Button from '../../components/Reusable/Button'

const AllFilter = () => {
  return (
    <div className='flex flex-col w-full lg:gap-10 gap-5 lg:mb-10 mb-5 text-white'>
      <div className='grid lg:grid-cols-3 w-full md:grid-cols-2 grid-cols-1 gap-6'>
        {
          data.map((d, i) => (
            <div key={i} className='bg-[#1C1B1C] w-full rounded-lg p-3 flex flex-col items-center justify-center'>
              <img src={d.img} alt="" />
              <div className='p-2 rounded-md bg-opacity-95 started w-full'>
                <div className='flex flex-row justify-between w-full'>
                  <p className='text-[17px] font-semibold text-white'>{d.title}</p>
                  <img src={d.icon} alt="" />
                </div>
                <p className='text-white text-opacity-75'>{d.sub}</p>
                <div className='flex lg:flex-row gap-4 flex-col items-center justify-between'>
                  <p className='flex text-transparent bg-clip-text text-black bg-gradient-to-r from-blue-900 to-blue-800 font-bold text-[14px]'>{d.amount}</p>
                  <Link to={`/productDetails/${d.title}`}>
                    <button className='bg-blue-400 p-2 hover:bg-[#06000A] py-3 rounded-lg'>{d.btn}</button>
                  </Link>
                </div>
              </div>
            </div>
          ))
        }

      </div>
      <div className='flex w-full justify-center items-center'>
        <Button
          title={"Scroll More"}
          link={"/"}
        />
      </div>
    </div>
  )
}

export default AllFilter